import { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

type UpvoteIconProps = Partial<CustomIconComponentProps> & { solid?: boolean };

const UpvoteIcon = ({ solid = false }: UpvoteIconProps) => {
  const outer =
    "M682.666667 955.733333H341.333333a17.066667 17.066667 0 0 1-17.066666-17.066666V529.066667H85.333333a17.066667 17.066667 0 0 1-12.066133-29.1328l426.666667-426.666667a17.0496 17.0496 0 0 1 24.132266 0l426.666667 426.666667A17.066667 17.066667 0 0 1 938.666667 529.066667H699.733333v409.6a17.066667 17.066667 0 0 1-17.066666 17.066666z";
  const inner =
    "M358.4 921.6h307.2V512a17.066667 17.066667 0 0 1 17.066667-17.066667h214.801066L512 109.4656 126.532267 494.933333H341.333333a17.066667 17.066667 0 0 1 17.066667 17.066667v409.6z";
  return (
    <svg
      className="upvote"
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      width="1em"
      height="1em"
    >
      <path
        d={solid ? outer : `${outer} ${inner}`}
        p-id="13936"
        fill="currentColor"
      ></path>
    </svg>
  );
};

export default UpvoteIcon;
